import Vue from "vue";
import GetTextPlugin from "vue-gettext";

function importTranslations() {
  let translations = JSON.stringify({});
  // Check if we are using production build and if so we will
  // prevent it from building in case we are missing translations.json file,
  // otherwise if it is development build we have a fallback to empty {}
  if (process.env.NODE_ENV === "production") {
    translations = require("../../translation/translations.json");
  } else {
    try {
      translations = require("../../translation/translations.json");
    } catch (e) {
      console.error("MISSING: /translation/translations.json");
    }
  }
  return translations;
}

Vue.use(GetTextPlugin, {
  availableLanguages: {
    en_US: "English",
    de_DE: "German",
    es_ES: "Spanish",
    fr_FR: "French",
    it_IT: "Italian",
    pt_PT: "Portuguese",
  },
  defaultLanguage: "en_US",
  translations: importTranslations(),
  silent: true,
});
